var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import _ from 'lodash';
import resolveStyleObject from '../resolvers/StyleObjectResolver';
import StyleObjectBuilder from '../styleObjectBuilder/StyleObjectBuilder';
function isNotUndefined(obj) {
    return obj !== undefined;
}
var VariationAccessor = /** @class */ (function () {
    function VariationAccessor(themeAccessor, themeVariations) {
        this.themeAccessor = themeAccessor;
        this.variationKeys = this.getVariationKeys(themeVariations);
        this.fallbackVariation = themeVariations.base;
        this.variations = this.calculateVariations(themeVariations, this.variationKeys);
    }
    VariationAccessor.prototype.getActiveThemeVariation = function (props) {
        var activeThemeVariationKey = this.resolveActiveVariationKey(props).replace('.base', '');
        //#region debug
        if (props.testId === 'plain')
            console.log(activeThemeVariationKey, props, this.variations);
        //#endregion
        return __assign(__assign({}, (this.variations.get(activeThemeVariationKey) || this.fallbackVariation)), _.pickBy(props, isNotUndefined));
    };
    VariationAccessor.prototype.getStyleObject = function (props) {
        var baseStylingSupports = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            baseStylingSupports[_i - 1] = arguments[_i];
        }
        return this.getStyleObjectBuilder.apply(this, __spreadArray([props], __read(baseStylingSupports), false)).build();
    };
    VariationAccessor.prototype.getStyleObjectBuilder = function (props) {
        var baseStylingSupports = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            baseStylingSupports[_i - 1] = arguments[_i];
        }
        var themeVariation = this.getActiveThemeVariation(props);
        var styleObject = resolveStyleObject(this.themeAccessor, themeVariation, 0, baseStylingSupports);
        return new StyleObjectBuilder(styleObject, themeVariation);
    };
    //#region internal methods
    VariationAccessor.prototype.getVariationKeys = function (themeVariations) {
        var _this = this;
        var variationKeys = [];
        Object.keys(themeVariations).forEach(function (key) {
            if (!isVariationTheme(themeVariations[key])) {
                variationKeys.push(key);
            }
            else {
                var variationKeysOfVariationsObject = _this.getVariationKeys(themeVariations[key])
                    // prepend the key prefix
                    .map(function (x) { return key + "." + x; });
                variationKeys.push.apply(variationKeys, __spreadArray([], __read(variationKeysOfVariationsObject), false));
            }
        });
        return variationKeys.map(function (x) { return x.replace('.base', ''); });
        return variationKeys;
    };
    VariationAccessor.prototype.resolveActiveVariationKey = function (props, variationKeys) {
        var e_1, _a;
        if (variationKeys === void 0) { variationKeys = this.variationKeys; }
        if (props.variationKey) {
            return props.variationKey;
        }
        var variationKeysOfLevel = variationKeys.map(function (x) {
            if (x === undefined) {
                return x;
            }
            return x.split('.')[0];
        });
        var _loop_1 = function (variationKey) {
            // if the attribute is undefined or false => continue
            if (!props[variationKey]) {
                return "continue";
            }
            if (props[variationKey] === true) {
                return { value: variationKey };
            }
            // here we know that props[key] is an object
            var prefix = variationKey + ".";
            var variationKeysOfVariation = variationKeys
                .filter(function (x) { return x.startsWith(variationKey); })
                .map(function (x) { return x.split(prefix)[1]; });
            return { value: "" + prefix + this_1.resolveActiveVariationKey(props[variationKey], variationKeysOfVariation) };
        };
        var this_1 = this;
        try {
            for (var variationKeysOfLevel_1 = __values(variationKeysOfLevel), variationKeysOfLevel_1_1 = variationKeysOfLevel_1.next(); !variationKeysOfLevel_1_1.done; variationKeysOfLevel_1_1 = variationKeysOfLevel_1.next()) {
                var variationKey = variationKeysOfLevel_1_1.value;
                var state_1 = _loop_1(variationKey);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (variationKeysOfLevel_1_1 && !variationKeysOfLevel_1_1.done && (_a = variationKeysOfLevel_1.return)) _a.call(variationKeysOfLevel_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return 'base';
    };
    VariationAccessor.prototype.calculateVariations = function (themeVariations, variationKeys) {
        var e_2, _a;
        var variations = new Map();
        try {
            for (var variationKeys_1 = __values(variationKeys), variationKeys_1_1 = variationKeys_1.next(); !variationKeys_1_1.done; variationKeys_1_1 = variationKeys_1.next()) {
                var variationKey = variationKeys_1_1.value;
                var variation = _.clone(themeVariations.base);
                // for the root base variation, nothing is to do
                if (variationKey === 'base') {
                    variations.set(variationKey, variation);
                    continue;
                }
                var variationKeyParts = variationKey.split('.');
                for (var i = 1; i <= variationKeyParts.length; i++) {
                    var valuePath = _.take(variationKeyParts, i);
                    var value = _.property(valuePath)(themeVariations);
                    if (isVariationTheme(value)) {
                        variation = __assign(__assign({}, variation), value.base);
                    }
                    else {
                        variation = __assign(__assign({}, variation), value);
                    }
                }
                variations.set(variationKey, variation);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (variationKeys_1_1 && !variationKeys_1_1.done && (_a = variationKeys_1.return)) _a.call(variationKeys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return variations;
    };
    return VariationAccessor;
}());
export default VariationAccessor;
function isVariationTheme(value) {
    // if the property has no base property, its an theme variation
    return _.has(value, 'base');
}
//# sourceMappingURL=VariationAccessor.js.map